module.exports = __webpack_public_path__ + "img/closed-eye.0338c442.svg";